import React from 'react';
import { HonorsBanner } from '../components/HonorsBanner';
import { PageHeader } from '../components/PageHeader';
export function Honors() {
  return <>
      <PageHeader eyebrow="Honors & Distinctions" title="Recognized at the highest levels of military and public service." data-id="element-319" data-mp="2qztncq3m9qsk" />
      <HonorsBanner data-id="element-320" data-mp="2i0q0db1bwr8s" />
    </>;
}